export const useRGBToHex = (rgbArray: number[]) => {
  if (rgbArray.length !== 3) {
    return "#000000";
  }

  // if any of the values are above 255 or below 0, return black
  // If any of the values are not numbers and are leters, return black
  if (rgbArray.some((value) => value > 255 || value < 0 || isNaN(value))) {
    return "#000000";
  }

  return (
    "#" +
    ((rgbArray[0] << 16) | (rgbArray[1] << 8) | rgbArray[2])
      .toString(16)
      .padStart(6, "0")
  );
};
